import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconSearch = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 36 36'>
    <title>{t('Search')}</title>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M15.396 3.747c-6.424 0-11.65 5.225-11.65 11.649 0 6.423 5.226 11.648 11.65 11.648 6.423 0 11.648-5.225 11.648-11.648 0-6.424-5.225-11.65-11.648-11.65zM26.5 24.558l8.097 8.097a1.373 1.373 0 1 1-1.943 1.943L24.558 26.5a14.287 14.287 0 0 1-9.162 3.29c-3.846 0-7.46-1.497-10.18-4.216A14.301 14.301 0 0 1 1 15.395c0-3.845 1.497-7.46 4.216-10.179A14.301 14.301 0 0 1 15.396 1c3.845 0 7.46 1.497 10.179 4.216a14.302 14.302 0 0 1 4.216 10.18c0 3.383-1.16 6.589-3.29 9.162z'
        stroke={fill}
        strokeWidth={0.5}
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconSearch)
